import { forwardRef } from 'react';
import { makeStyles } from '@mui/styles';
import MuiMenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';

import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing, palette }) => ({
    icon: {
      minWidth: 'unset',
      marginRight: spacing(1),
      color: palette.text.onMain,
    },
    rightIcon: {
      marginLeft: 'auto',
      color: palette.text.onMain,
      minWidth: 0,
    },
    menuItemRoot: {
      display: 'flex',
      paddingTop: spacing(1),
      paddingBottom: spacing(1),
      color: palette.text.onMain,
      '&:hover': {
        color: 'inherit',
      },
    },

    itemTopContainer: {
      display: 'flex',
      width: '100%',
      fontWeight: ({ caption }) => (caption ? 'bold' : 'normal'),
      '& > *': {
        alignItems: 'center',
      },
    },
    caption: {
      whiteSpace: 'initial',
    },
  })
);

const MenuItem = forwardRef(
  (
    { label, caption = null, data, icon: Icon = null, rightIcon: RightIcon = null, ...others },
    ref
  ) => {
    const classes = useStyles({ caption });

    return (
      <MuiMenuItem component="a" classes={{ root: classes.menuItemRoot }} ref={ref} {...others}>
        <div>
          <div className={classes.itemTopContainer}>
            {Icon && (
              <ListItemIcon classes={{ root: classes.icon }}>
                <Icon />
              </ListItemIcon>
            )}
            <Typography variant="body">{label}</Typography>
          </div>
          {caption && (
            <Typography variant="caption" component="div" className={classes.caption}>
              {caption}
            </Typography>
          )}
        </div>
        {RightIcon && (
          <ListItemIcon classes={{ root: classes.rightIcon }}>
            <RightIcon />
          </ListItemIcon>
        )}
      </MuiMenuItem>
    );
  }
);

export default MenuItem;
